import { ErrorNotice } from '../components/ErrorNotice';
import type { FieldSetProblem } from './extraction-fields-shared';

/**
 * A refused change to the extracted-field set — CLM-109. The CLM-111
 * `NominationProblemNotice` precedent: a refusal the API names is this banner,
 * in the page's own words and with the cap it hit, never `ErrorNotice`'s copy
 * for its kind — that copy is written for other surfaces (a `conflict` is
 * verify-field's "Another reviewer settled this field"; a `validation` says the
 * page has a defect). A 409 is neutral (`up`, `role=status`): nothing failed,
 * the registry moved. A 400 or 404 is `bad`.
 *
 * Anything else — a 403, a 5xx, a code this build has no words for — is still
 * `ErrorNotice`, by kind. The correlation id is always shown.
 */
export function FieldSetProblemNotice({ problem }: { readonly problem: FieldSetProblem }) {
  const { refusal } = problem;
  if (refusal === null) return <ErrorNotice kind={problem.kind} correlation_id={problem.correlation_id} />;
  return (
    <div className={`banner ${refusal.tone}`} role="status" data-testid="field-set-refusal" data-code={refusal.code}>
      <p className="notice-head">
        <strong>{refusal.head}</strong>
      </p>
      <p>{refusal.body}</p>
      {problem.correlation_id === null || problem.correlation_id === '' ? null : (
        <p className="mut">
          Correlation id <code>{problem.correlation_id}</code>
        </p>
      )}
    </div>
  );
}
